@let q = question();
<div [formGroup]="form">
  <app-feedback-title [title]="q.title" [subtitle]="q.subtitle" />
  <div class="currency-form">
    <span i18n>My prices are in</span>
    <div class="currencies">
      <div class="currency">
        <input type="radio" [formControlName]="q.id" (change)="currencyChange($event)" value="wildcard:eur" id="eur" />
        <label i18n for="eur">Euro (€)</label>
      </div>
      <div class="currency">
        <input type="radio" [formControlName]="q.id" (change)="currencyChange($event)" value="wildcard:usd" id="usd" />
        <label i18n for="usd">US dollars ($)</label>
      </div>
    </div>
  </div>
  <div class="options">
    @for (option of q.options; track option.id) {
      <div class="option">
        <label for="{{ option.id }}">
          <span>{{ option.label }}</span>
          <span>{{ currency }}</span>
        </label>
        <div class="input-wrapper">
          @let formControlName = option.id;
          <input
            type="text"
            [id]="formControlName"
            [value]="getInputValue(formControlName)"
            (input)="onInputChange(formControlName, $event)"
          />
          @if (form.get(formControlName)?.invalid && form.get(formControlName)?.touched) {
            <div i18n class="error">Only numbers allowed</div>
          }
        </div>
      </div>
    }
  </div>
</div>
